import api from 'api/axiosInstance';
import type { MonthlyPaymentVolume } from 'types/settings.types';
import type { AvailableCountries } from 'types/users.types';

type AccountableOnboardingBody = {
  country?: AvailableCountries;
  userId?: string;
  _id?: string;
  filepath?: string;
  filepaths?: string[];
  taxID?: string;
  skipDocumentScan?: boolean;
  personalDetails?: {
    firstName?: string;
    lastName?: string;
    email?: string;
    address?: {
      city?: string;
      state?: string;
      street?: string;
      zip?: string;
    };
  };
  businessActivity?: string;
  businessActivityDescription?: string;
  monthlyPaymentVolume?: MonthlyPaymentVolume;
  companyName?: string;
  additionalBusinessActivityDescription?: string;
};

type AccountableOnboardingResponse = {
  businessActivity?: string;
  businessActivityDescription?: string;
  companyName: string;
  country: AvailableCountries;
  created: string;
  filepaths: string[];
  furthestStepCompleted: string;
  modified: string;
  monthlyPaymentVolume: MonthlyPaymentVolume;
  onboardingId: string;
  personalDetails: {
    firstName: string;
    lastName: string;
    email: string;
    address: {
      city: string;
      state: string;
      street: string;
      zip: string;
    };
  };
  reminders: { kycVerification: { lastSentAt: string } };
  status: string;
  supportingDocumentCollectionId: string;
  taxID: string;
  userId: string;
  __v: number;
  _id: string;
  documentIssues?: { filepath: string; issues: string[] }[];
};

const updateAccountableBankingOnboarding = (
  body: AccountableOnboardingBody,
): Promise<AccountableOnboardingResponse> =>
  api.patch('/v2/accountable-banking/onboarding', body);

export default updateAccountableBankingOnboarding;
